import { Directive, HostBinding, Optional } from '@angular/core';
import { NglFormGroup } from '../groups/group';
import { NglFormGroupAlternate } from '../groups/group-alt';
var NglFormInput = (function () {
    function NglFormInput() {
    }
    NglFormInput.decorators = [
        { type: Directive, args: [{
                    selector: 'input[nglFormControl]:not([type=checkbox]), input[nglFormControl]:not([type=radio])',
                    host: {
                        '[class.slds-input]': 'true',
                    },
                },] },
    ];
    /** @nocollapse */
    NglFormInput.ctorParameters = function () { return []; };
    NglFormInput.propDecorators = {
        'id': [{ type: HostBinding, args: ['id',] },],
        'describedBy': [{ type: HostBinding, args: ['attr.aria-describedby',] },],
    };
    return NglFormInput;
}());
export { NglFormInput };
;
var NglFormTextarea = (function () {
    function NglFormTextarea() {
    }
    NglFormTextarea.decorators = [
        { type: Directive, args: [{
                    selector: 'textarea[nglFormControl]',
                    providers: [{ provide: NglFormInput, useExisting: NglFormTextarea }],
                    host: {
                        '[class.slds-textarea]': 'true',
                    },
                },] },
    ];
    /** @nocollapse */
    NglFormTextarea.ctorParameters = function () { return []; };
    NglFormTextarea.propDecorators = {
        'id': [{ type: HostBinding, args: ['id',] },],
        'describedBy': [{ type: HostBinding, args: ['attr.aria-describedby',] },],
    };
    return NglFormTextarea;
}());
export { NglFormTextarea };
var NglFormSelect = (function () {
    function NglFormSelect() {
    }
    NglFormSelect.decorators = [
        { type: Directive, args: [{
                    selector: 'select[nglFormControl]',
                    providers: [{ provide: NglFormInput, useExisting: NglFormSelect }],
                    host: {
                        '[class.slds-select]': 'true',
                    },
                },] },
    ];
    /** @nocollapse */
    NglFormSelect.ctorParameters = function () { return []; };
    NglFormSelect.propDecorators = {
        'id': [{ type: HostBinding, args: ['id',] },],
        'describedBy': [{ type: HostBinding, args: ['attr.aria-describedby',] },],
    };
    return NglFormSelect;
}());
export { NglFormSelect };
var NglFormCheckbox = (function () {
    function NglFormCheckbox() {
        this.type = 'checkbox';
        this.assistive = false;
    }
    NglFormCheckbox.decorators = [
        { type: Directive, args: [{
                    selector: 'input[nglFormControl][type=checkbox]',
                    host: {
                        '[class.slds-assistive-text]': 'assistive',
                    },
                },] },
    ];
    /** @nocollapse */
    NglFormCheckbox.ctorParameters = function () { return []; };
    NglFormCheckbox.propDecorators = {
        'id': [{ type: HostBinding, args: ['id',] },],
        'describedBy': [{ type: HostBinding, args: ['attr.aria-describedby',] },],
    };
    return NglFormCheckbox;
}());
export { NglFormCheckbox };
var NglFormRadio = (function () {
    function NglFormRadio(formGroup, formGroupAlt) {
        this.type = 'radio';
        this.name = "name_" + (formGroup || formGroupAlt).uid;
    }
    NglFormRadio.decorators = [
        { type: Directive, args: [{
                    selector: 'input[nglFormControl][type=radio]',
                    providers: [{ provide: NglFormCheckbox, useExisting: NglFormRadio }],
                },] },
    ];
    /** @nocollapse */
    NglFormRadio.ctorParameters = function () { return [
        { type: NglFormGroup, decorators: [{ type: Optional },] },
        { type: NglFormGroupAlternate, decorators: [{ type: Optional },] },
    ]; };
    NglFormRadio.propDecorators = {
        'id': [{ type: HostBinding, args: ['id',] },],
        'name': [{ type: HostBinding, args: ['attr.name',] },],
    };
    return NglFormRadio;
}());
export { NglFormRadio };
//# sourceMappingURL=input.js.map